import React from 'react'
import styles from './LatestTransaction.module.sass'
import { Icon } from '../../../ui/Icon'
import classNames from 'classnames'
import { Transaction } from '../../../../app/models/generated'
import last_transaction_icon from '../../../../assets/transactions_icon.svg'
import {
    getTimeFromTimestamp,
    processedStringFromApi,
    round,
    stringTruncateFromCenter,
} from '../../../../utils'
import { Status } from '../../../ui/Status'
import { TypeOfTransaction } from '../../../ui/TypeOfTransaction'
import { NavLink } from 'react-router-dom'

interface wrapperTransaction {
    transaction: Transaction
}

export const LatestTransaction = (props: wrapperTransaction) => {
    const currentTransaction = props.transaction

    currentTransaction.tx_types = currentTransaction.tx_types.length
        ? currentTransaction.tx_types
        : ['coin_transfer']

    const toAddress = currentTransaction.to
        ? currentTransaction.to.hash
        : currentTransaction.created_contract?.hash

    const value =
        currentTransaction.value === '0'
            ? 0
            : round(Number(currentTransaction.fee?.value) / 10 ** 18, 5)

    const feeValue = round(Number(currentTransaction.fee?.value) / 10 ** 18, 5)

    return (
        <div className={styles.latestTransaction}>
                    {/* <div className={styles.topLeftInfo}>
                        <TypeOfTransaction
                            theme={currentTransaction.tx_types[0]}>
                            {processedStringFromApi(
                                currentTransaction.tx_types[0]
                            )}
                        </TypeOfTransaction>
                        <Status theme={currentTransaction.status}></Status>
                    </div> */}
                    <div className={styles.transactionHead}>
                        <div className={styles.transactionHeadMain}>
                            <img 
                                src={last_transaction_icon}
                                alt="last_transaction_icon" 
                            />
                        </div>
                        
                        <div className={styles.transactionfont}>
                            <div>
                                <NavLink
                                to={'/transaction/' + currentTransaction?.hash}
                                >
                                {stringTruncateFromCenter(
                                    currentTransaction?.hash,
                                    8
                                )}
                                </NavLink>
                            </div>
                            <h2>
                                {/* <p className={styles.time}>
                                    {getTimeFromTimestamp(currentTransaction.timestamp)}
                                </p> */}
                                6 secs ago
                            </h2>
                        </div>
                        
                    </div>
                    <div className={styles.transactionfont}>
                        <div className={styles.transactionfont1}>
                            <p>From </p>
                            <NavLink
                                to={'/address/' + currentTransaction.from?.hash}>
                                {stringTruncateFromCenter(
                                    currentTransaction.from?.hash,
                                    8
                                )}
                            </NavLink>
                        </div>
                        <div className={styles.transactionfont1}>
                            <p>To </p>
                            <NavLink
                                to={'/address/' + toAddress}>
                                {stringTruncateFromCenter(toAddress, 8)}
                            </NavLink>
                        </div>
                    </div>
                        
                    <div className={styles.milfont}>
                        {/* currentblock's MIL value */}
                        500 MIL
                    </div>
            </div>
    )
}
